module.exports = __webpack_public_path__ + "lastSlide.jpg?fcefdebe18cb4b158d1672ce31bf2d2c";